/* No comparison module, preview or AI request until the visitor opens this panel. */
(() => {
  if (window.zbCompareLoader) return;
  window.zbCompareLoader = true;
  const loaded = new WeakMap(), pending = new WeakSet();
  let styles;
  const css = url => styles || (styles = new Promise((resolve, reject) => {
    const link = document.createElement('link');link.rel = 'stylesheet';link.href = url;
    link.onload = resolve;link.onerror = () => {link.remove();styles = null;reject(Error('css'));};
    document.head.append(link);
  }));
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-zb-compare] .zb-compare-open');
    if (!trigger) return;
    const root = trigger.closest('[data-zb-compare]');
    if (loaded.has(root)) {loaded.get(root).toggle();return;}
    if (pending.has(root)) return;
    pending.add(root);trigger.setAttribute('aria-busy','true');
    const message = root.querySelector('.zb-compare-load');message.hidden = false;message.textContent = 'Otwieram porównanie…';
    try {
      const [,module] = await Promise.all([css(root.dataset.styles),import(root.dataset.module)]);
      if (!root.isConnected) return;
      const view = module.mount(root);loaded.set(root,view);message.hidden = true;view.toggle();
    } catch (_) {message.textContent = 'Nie udało się otworzyć porównania. Kliknij ponownie, aby spróbować jeszcze raz.';}
    finally {pending.delete(root);trigger.removeAttribute('aria-busy');}
  });
})();
